import { useTranslation } from "react-i18next";

import cqddLogo from "@/assets/logo-cqdd.svg";
import cqddLogoWhite from "@/assets/logo-cqdd-blanc.svg";
import { ACCOUNTS_ORIGIN } from "@/lib/config";

/**
 * Global footer (parity with the old app, which showed it on every page):
 * CQDD logo + copyright + CQDD link + privacy-policy PDF. The PDF is served by
 * Django. The logo swaps to its white variant in dark theme.
 */
export function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t">
      <div className="container flex flex-wrap items-center justify-between gap-2 py-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-3">
          <a
            href="https://www.cqdd.qc.ca/"
            target="_blank"
            rel="noreferrer"
            aria-label={t("shell.footer.org")}
            className="shrink-0"
          >
            <img
              src={cqddLogo}
              alt={t("shell.footer.org")}
              className="h-8 w-auto dark:hidden"
            />
            <img
              src={cqddLogoWhite}
              alt={t("shell.footer.org")}
              className="hidden h-8 w-auto dark:block"
            />
          </a>
          <p>
            ©{new Date().getFullYear()}{" "}
            <a
              href="https://www.cqdd.qc.ca/"
              target="_blank"
              rel="noreferrer"
              className="underline-offset-4 hover:underline"
            >
              {t("shell.footer.org")}
            </a>
            . {t("shell.footer.rights")}
          </p>
        </div>
        <a
          href={`${ACCOUNTS_ORIGIN}/static/pdfs/politique-de-confidentialite.pdf`}
          target="_blank"
          rel="noreferrer"
          className="underline-offset-4 hover:underline"
        >
          {t("shell.footer.privacy")}
        </a>
      </div>
    </footer>
  );
}
